import { render, staticRenderFns } from "./CFormGeneral.vue?vue&type=template&id=04431b26&"
import script from "./CFormGeneral.vue?vue&type=script&lang=js&"
export * from "./CFormGeneral.vue?vue&type=script&lang=js&"
import style0 from "./CFormGeneral.vue?vue&type=style&index=0&id=04431b26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports